// extracted by mini-css-extract-plugin
export default {"info":"styles_info__GHsMt","btnContainer":"styles_btnContainer__-7DLF","btn":"styles_btn__EcZHu","spinner":"styles_spinner__Wig31","disabled":"styles_disabled__ri3Em"};